import actions from './actions';

const ReserveModule = {
  namespaced: true,
  actions,
};

export default ReserveModule;
